// test172
(172 && 0);
